module.exports = __webpack_public_path__ + "static/media/diktat-33.6f12614a.mp3";